import { SEO } from "@/components/SEO";
import { AboutHero } from "../components/site/about/AboutHero";
import { QuickToLaugh } from "../components/site/about/QuickToLaugh";
import { EverydayJoy } from "../components/site/about/EverydayJoy";
import { ChildhoodWonder } from "../components/site/about/ChildhoodWonder";
import { NightlyGratitude } from "../components/site/about/NightlyGratitude";
import { MountainPerspective } from "../components/site/about/MountainPerspective";
import { DreamReminders } from "../components/site/about/DreamReminders";
import { QuietPause } from "../components/site/about/QuietPause";
import { AboutInvitation } from "../components/site/about/AboutInvitation";

export default function About() {
  return (
    <div data-testid="about-page">
      <SEO
        title="About Lara"
        description="Meet Lara Parrish — author, speaker, and life coach behind Blueprint4Joy®, on a lifelong curiosity about what makes a joyful life."
        path="/about"
      />
      <AboutHero />
      <QuickToLaugh />
      <EverydayJoy />
      <ChildhoodWonder />
      <NightlyGratitude />
      <MountainPerspective />
      <DreamReminders />
      <QuietPause />
      <AboutInvitation />
    </div>
  );
}
